import styled from 'styled-components';
import { mq, rgba } from 'stylesheets/utils';
import { Swiper } from 'swiper/react';

export const PresentImage = styled(Swiper)`
  max-width: 343px;
  height: 328px;
  border-radius: 4px;
  margin: 0 0 10px 0;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.16);
  ${mq(992)} {
    max-width: 100%;
  }
  .swiper-slide {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 10px !important;
    height: 17px !important;
    margin-bottom: 0;
    right: 23px;
    transform: scale(1, 1) /*rtl: scale(-1, 1) */;
    &::after {
      font-size: 18px;
      color: ${({ theme }) => theme.colors.black};
      z-index: 1;
    }
    &::before {
      position: absolute;
      content: '';
      width: 36px;
      height: 36px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: ${({ theme }) => rgba(theme.colors.white, 0.1)};
      border-radius: 50%;
    }
    &.swiper-button-prev {
      right: unset;
      left: 23px;
    }
  }
`;

export const ThumpSlider = styled(Swiper)`
  height: 46px;
  margin: 0;
  .swiper-slide {
    max-width: 46px;
    min-width: 46px;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.lightenGray};
  }
`;
export const ThumpSLideWrapper = styled.div`
  display: flex;
  align-items: center;
  ${mq(992)} {
    margin-bottom: 20px;
  }
`;

export const MoreThumps = styled.p`
  min-width: 24px;
  max-width: 24px;
  max-height: 24px;
  min-height: 24px;
  border-radius: 50%;
  line-height: 26px;
  text-align: center;
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.arrowBackground};
`;
